(function () {
  var STORAGE_KEY = 'tt_wishlist';
  var PAGE_URL = '/pages/onskeliste';

  function getList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return raw.filter(function(i) { return i && i.id && i.handle; });
    } catch(e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  }
  function isLiked(id) {
    return getList().some(function(i) { return i.id === String(id); });
  }
  function toggleProduct(id, handle) {
    var list = getList();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === String(id)) { idx = i; break; }
    }
    if (idx !== -1) { list.splice(idx, 1); saveList(list); return false; }
    list.push({ id: String(id), handle: handle || '' });
    saveList(list);
    return true;
  }

  function updateBadge() {
    var badge = document.querySelector('.tt-wishlist-count');
    if (!badge) return;
    var count = getList().length;
    badge.textContent = count > 0 ? count : '';
  }

  function syncHearts() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var liked = isLiked(btn.dataset.wishlistBtn);
      btn.classList.toggle('tt-heart--active', liked);
      btn.setAttribute('aria-label', liked ? 'Fjern fra ønskeliste' : 'Legg til i ønskeliste');
    });
    updateBadge();
  }

  function isOnWishlistPage() {
    return window.location.pathname.indexOf(PAGE_URL) === 0;
  }

  function getUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('shared');
    var name = params.get('name');
    if (!shared) return null;
    return {
      items: shared.split(',').filter(Boolean).map(function(entry) {
        var parts = entry.split(':');
        return { id: parts[0], handle: parts[1], variantId: parts[2] || null };
      }),
      name: name ? decodeURIComponent(name) : null
    };
  }

  // ── Shopify Customer Events tracking ──
  function trackEvent(name, data) {
    try {
      document.dispatchEvent(new CustomEvent('shopify:' + name, {
        bubbles: true,
        detail: data || {}
      }));
    } catch(e) {}
  }

  function copyToClipboard(text, onSuccess) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(function() {
        fallbackCopy(text, onSuccess);
      });
    } else {
      fallbackCopy(text, onSuccess);
    }
  }

  function fallbackCopy(text, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); onSuccess(); } catch(e) {}
    document.body.removeChild(ta);
  }

  function addToCart(variantId, productHandle, btn) {
    btn.disabled = true;
    btn.textContent = 'Legger til...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Lagt til!';
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

      // Track: kjøp fra ønskeliste
      trackEvent('wishlist_add_to_cart', {
        variant_id: variantId,
        product_handle: productHandle
      });

      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = 'LEGG I HANDLEKURV';
      }, 2000);
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'Prøv igjen';
    });
  }

  function buildQuickBuy(product, card, preselectedVariantId) {
    var variants = product.variants;
    var qb = document.createElement('div');
    qb.className = 'tt-quickbuy';

    var select = document.createElement('select');
    select.className = 'tt-quickbuy__select';
    select.setAttribute('aria-label', 'Velg variant');

    if (variants.length > 1 && !preselectedVariantId) {
      var defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = 'Velg størrelse';
      defaultOpt.disabled = true;
      defaultOpt.selected = true;
      select.appendChild(defaultOpt);
    }

    variants.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = v.id;
      opt.textContent = v.title;
      if (!v.available) {
        opt.textContent += ' - Utsolgt';
        opt.disabled = true;
      }
      select.appendChild(opt);
    });

    if (preselectedVariantId) {
      select.value = preselectedVariantId;
    } else if (variants.length === 1) {
      select.selectedIndex = 0;
    }

    var btn = document.createElement('button');
    btn.className = 'tt-quickbuy__btn';
    btn.type = 'button';

    if (variants.length === 1 && !variants[0].available) {
      btn.textContent = 'Utsolgt';
      btn.disabled = true;
    } else {
      btn.textContent = 'LEGG I HANDLEKURV';
      btn.addEventListener('click', function() {
        var variantId = select.value;
        if (!variantId) {
          select.focus();
          select.style.borderColor = '#e00';
          setTimeout(function() { select.style.borderColor = ''; }, 1500);
          return;
        }
        addToCart(variantId, product.handle, btn);
      });
    }

    qb.appendChild(select);
    qb.appendChild(btn);
    card.appendChild(qb);
  }

  function renderCards(list, isShared) {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    grid.innerHTML = '';

    if (list.length === 0) {
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');

    list.forEach(function(item) {
      var handle = item.handle;
      var id = item.id;
      var variantId = item.variantId || null;

      fetch('/products/' + handle + '?section_id=wishlist-product-card')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html.trim();
          var card = wrapper.querySelector('product-block');
          if (!card) return;
          card.setAttribute('data-wishlist-id', id);

          var heartBtn = card.querySelector('[data-wishlist-btn]');
          if (heartBtn) {
            if (isShared) {
              heartBtn.style.display = 'none';
            } else {
              heartBtn.classList.add('tt-heart--active');
            }
          }

          fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(product) {
              buildQuickBuy(product, card, variantId);
            });

          grid.appendChild(card);
        })
        .catch(function() {});
    });
  }

  function renderWishlistPage() {
    if (!isOnWishlistPage()) return;

    var urlData = getUrlParams();
    if (urlData) {
      renderCards(urlData.items, true);

      var actions = document.querySelector('.tt-wishlist-actions');
      if (actions) actions.style.display = 'none';

      var heading = document.querySelector('[data-wishlist-heading]');
      if (heading) {
        heading.textContent = urlData.name ? urlData.name + 's ønskeliste' : 'Delt ønskeliste';
      }

      var notice = document.querySelector('[data-wishlist-shared-notice]');
      if (notice) notice.removeAttribute('hidden');
      return;
    }

    renderCards(getList(), false);
  }

  function getSelectedVariants() {
    var list = getList();
    return list.map(function(item) {
      var card = document.querySelector('product-block[data-wishlist-id="' + item.id + '"]');
      var variantId = null;
      if (card) {
        var select = card.querySelector('.tt-quickbuy__select');
        if (select && select.value) variantId = select.value;
      }
      return { id: item.id, handle: item.handle, variantId: variantId };
    });
  }

  function showShareModal() {
    var overlay = document.createElement('div');
    overlay.id = 'tt-share-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;border-radius:8px;padding:32px;max-width:420px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.2);';

    modal.innerHTML =
      '<h3 style="margin:0 0 8px;font-size:1.1em;font-weight:600;">Del ønskelisten din</h3>' +
      '<p style="margin:0 0 16px;font-size:0.85em;color:#666;">Skriv navnet ditt så mottakeren vet hvem listen er fra.</p>' +
      '<div style="margin:0 0 20px;padding:12px 14px;background:#f9f9f9;border:1px solid #eee;border-radius:6px;font-size:0.82em;color:#555;line-height:1.5;">' +
        '💡 <strong>Tips:</strong> Vil du dele med valgte størrelser? Trykk <em>Gå tilbake</em> og velg størrelser på produktene dine først — så vet mottakeren nøyaktig hva du ønsker deg.' +
      '</div>' +
      '<label style="display:block;font-size:0.85em;font-weight:500;margin-bottom:6px;">Navnet ditt</label>' +
      '<input id="tt-share-name" type="text" placeholder="f.eks. Frederik" style="width:100%;padding:10px 12px;border:1px solid #ccc;border-radius:4px;font-size:0.95em;box-sizing:border-box;margin-bottom:16px;">' +
      '<div style="display:flex;gap:10px;">' +
        '<button id="tt-share-copy-btn" type="button" style="flex:1;padding:10px;background:#000;color:#fff;border:none;border-radius:4px;font-size:0.9em;font-weight:600;cursor:pointer;">Kopier lenke</button>' +
        '<button id="tt-share-back-btn" type="button" style="padding:10px 16px;background:#fff;color:#333;border:1px solid #ccc;border-radius:4px;font-size:0.9em;cursor:pointer;">Gå tilbake</button>' +
      '</div>';

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    var nameInput = document.getElementById('tt-share-name');
    nameInput.focus();

    function closeModal() {
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
    }

    document.getElementById('tt-share-back-btn').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    function doShare() {
      var name = nameInput.value.trim();
      var variants = getSelectedVariants();
      var ids = variants.map(function(i) {
        return i.id + ':' + i.handle + (i.variantId ? ':' + i.variantId : '');
      }).join(',');
      var url = window.location.origin + PAGE_URL + '?shared=' + ids + (name ? '&name=' + encodeURIComponent(name) : '') + '&utm_source=wishlist&utm_medium=share&utm_campaign=onskeliste';
      var copyBtn = document.getElementById('tt-share-copy-btn');

      copyToClipboard(url, function() {
        // Track: delelenke generert
        trackEvent('wishlist_share', {
          item_count: variants.length,
          shared_by: name || 'anonym'
        });

        copyBtn.textContent = 'Kopiert!';
        setTimeout(closeModal, 1200);
      });
    }

    document.getElementById('tt-share-copy-btn').addEventListener('click', doShare);
    nameInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') doShare();
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.dataset.wishlistBtn;
    var handle = btn.dataset.wishlistHandle || '';
    var liked = toggleProduct(id, handle);
    btn.classList.toggle('tt-heart--active', liked);
    btn.setAttribute('aria-label', liked ? 'Fjern fra ønskeliste' : 'Legg til i ønskeliste');
    btn.classList.add('tt-heart--pop');
    setTimeout(function() { btn.classList.remove('tt-heart--pop'); }, 350);
    updateBadge();

    // Track: like/unlike
    if (liked) {
      trackEvent('wishlist_like', {
        product_id: id,
        product_handle: handle
      });
    }

    if (isOnWishlistPage() && !liked && !getUrlParams()) {
      var card = document.querySelector('product-block[data-wishlist-id="' + id + '"]');
      if (card) card.remove();
      if (getList().length === 0) {
        var empty = document.querySelector('[data-wishlist-empty]');
        if (empty) empty.removeAttribute('hidden');
      }
    }
  });

  function initActions() {
    var clearBtn = document.getElementById('tt-clear-wishlist');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (confirm('Er du sikker på at du vil tømme ønskelisten din?')) {
          saveList([]);
          updateBadge();
          syncHearts();
          window.location.reload();
        }
      });
    }

    var shareBtn = document.getElementById('tt-share-wishlist');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        if (getList().length === 0) {
          alert('Ønskelisten din er tom — legg til produkter først.');
          return;
        }
        showShareModal();
      });
    }
  }

  function init() {
    syncHearts();
    renderWishlistPage();
    initActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
